/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import McResultSubmitAnswers from './McResultSubmitAnswers';

/**
 * The McOutputRouteMcSubmit model module.
 * @module model/McOutputRouteMcSubmit
 * @version 1.0
 */
class McOutputRouteMcSubmit {
    /**
     * Constructs a new <code>McOutputRouteMcSubmit</code>.
     * @alias module:model/McOutputRouteMcSubmit
     */
    constructor() { 
        
        McOutputRouteMcSubmit.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>McOutputRouteMcSubmit</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/McOutputRouteMcSubmit} obj Optional instance to populate.
     * @return {module:model/McOutputRouteMcSubmit} The populated <code>McOutputRouteMcSubmit</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new McOutputRouteMcSubmit();

            if (data.hasOwnProperty('result')) {
                obj['result'] = McResultSubmitAnswers.constructFromObject(data['result']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/McResultSubmitAnswers} result
 */
McOutputRouteMcSubmit.prototype['result'] = undefined;






export default McOutputRouteMcSubmit;

